import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {PromoPanelEvents} from "@nolimitcity/promo-panel/bin/events/PromoPanelEvents";
import {WIN_CAP_MODES} from "../server/IKMDData";

export class KMDxBetReelFrame extends PIXI.Container implements StageLayer {

    private _tl: gsap.core.Timeline | null;
    private _frame: PIXI.spine.Spine;
    private readonly _fadeTl: gsap.core.Timeline;
    private _isPlaying: boolean;
    private _currentBet: number;
    private _isPromoPanelClosed: boolean = true;

    constructor() {
        super();
        this.name = "KMDxBetReelFrame";

        this.visible = false;
        this.position.set(216, 315);

        // #224
        this._fadeTl = gsap.timeline({
            paused: true,
            repeat: -1
        });
        this._fadeTl.to(this, {
            duration: 3,
            alpha: 0.1
        });
        this._fadeTl.to(this, {
            duration: 3,
            alpha: 0.5
        });

        this._frame = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("xBetReelFrame"));
        this.addChild(this._frame);

        KennethMustDie.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_OPENED, () => {
            this.onPromoPanelOpened();
        });
        KennethMustDie.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_CLOSED, () => {
            this.onPromoPanelClosed();
        });

        KennethMustDie.apiPlugin.events.on(APIEvent.CURRENT_BET, (currentBet: string) => {
            this.onBetLevelChangeFromKeypad(parseFloat(currentBet));
        });

        this._isPlaying = false;
        this._currentBet = 0;

        this.alpha = 0.5;
    }

    public toggleXBetFrame(visible: boolean, calledFromKeypad: boolean = false): void {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (this._tl) {
            this._tl.totalProgress(1);
            this._tl.kill();
        }
        this._tl = null;

        if (!calledFromKeypad && this.visible === visible) {
            return;
        }

        // #224 -> guy in cage reacting to xBet toggle
        KennethMustDie.reelFrame.fromXBet(visible);

        if (this._fadeTl) {
            this._fadeTl.pause(0);
        }

        this._isPlaying = visible;

        if (visible) {
            tl.add([
                () => {
                    this.visible = true;
                },
                KennethMustDie.createTimelineForAnimation(this._frame, 0, "start", false)
            ]);
            tl.add([
                KennethMustDie.createTimelineForAnimation(this._frame, 0, "loop", true),
                this._fadeTl.play()
            ]);

            tl.timeScale(0.5);
        } else {
            tl.to(this, {
                duration: 0.2,
                alpha: 0
            });
            tl.add(() => {
                this.visible = false;
                this.alpha = 0.5;
            });
        }

        this._tl = tl;
    }

    public onBetLevelChangeFromKeypad(newBet: number): void {
        if (!this._isPromoPanelClosed) {
            return;
        }

        const maxBet: number = (KennethMustDie.apiPlugin.betLevel.getSelectedBetLevelModeName() === WIN_CAP_MODES.CAP_MODE_STANDARD ? KennethMustDie.maxBetStandard : KennethMustDie.maxBet10K);

        if (this._currentBet !== newBet && ((newBet === maxBet && this._currentBet !== maxBet) || (newBet !== maxBet && this._currentBet === maxBet))) {
            this._frame = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset(newBet === maxBet ? "xBetReelFrameMaxBet" : "xBetReelFrame"));
            this.removeChildren();
            this.addChild(this._frame);

            if (this._isPlaying) {
                this.toggleXBetFrame(true, true);
            }
        }

        this._currentBet = newBet;
    }

    private onPromoPanelOpened(): void {
        this._isPromoPanelClosed = false;
    }

    private onPromoPanelClosed(): void {
        this._isPromoPanelClosed = true;
    }
}